import { ReactNode } from "react";

/**
 * Used as a helper for MUI Skeleton logic.
 * @param config The configuration for builder
 * @param componentBuilder The function that builds the component
 * @returns The ReactNode to display based on config and componentBuilder
 */
export function skeletonBuilder<Item>(
  config: ISkeletonBuilderConfig<Item>,
  componentBuilder: (items: Array<Item | undefined>, isLoading: Boolean) => ReactNode
): ReactNode {
  const { isLoading, itemCount, items, onEmpty } = config;
  const loading = isLoading ?? items === undefined;
  if (onEmpty && items && items.length === 0 && !loading) return onEmpty();
  const skeletonItems = Array.from(new Array(itemCount));
  if (loading) {
    return componentBuilder(skeletonItems, loading);
  }
  const itemsOrSkeletonItems = items ?? skeletonItems;
  return componentBuilder(itemsOrSkeletonItems, loading);
}

interface ISkeletonBuilderConfig<Item> {
  /** If undefined the isLoading will be determined using items. If items is undefined then loading will be true.*/
  isLoading?: Boolean;
  /** The number of skeleton items to create when loading. */
  itemCount: number;
  /** Called when items is empty and loading is false.  */
  onEmpty?: () => ReactNode;
  /** The items to use when loading is false. */
  items?: Array<Item>;
}
